<template>
  <v-card flat color="transparent" >
    <v-container>
      <v-card-title>
        <h1
          class="component-header"
          v-html="
            $t('home.description.headline') != 'home.description.headline'
              ? $t('home.description.headline')
              : ''
          "
        ></h1>
      </v-card-title>
      <v-card-text :class="'text-center'">
        <p class="mb-0" v-html="$t('home.description.text')" style="font-size: 18px"></p>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    center: Boolean,
  },
};
</script>

<style>

</style>